<template>
	<div class="upload-file">
        <dropzone id="file-dropzone" :options="options" v-on:vdropzone-sending="UploadFile" v-on:vdropzone-complete="HandleResponse"></dropzone>
	</div>
</template>

<script>
    import dropzone from 'vue2-dropzone';
	export default {
        components: {
            dropzone
        },

		props: { folderId: Number, fileId: Number },

		data(){
            return {
                options: {
                    url: '/api/documents/file/upload',
                    headers: {
                        'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
                    }
                }
            }
        },

        methods: {
            UploadFile(file, xhr, data){
                data.append('folder_id', this.folderId);
                data.append('job_id', this.$store.state.job_id);
                data.append('job_type', this.$store.state.job_type);

                if(this.fileId != undefined){
                    data.append('file_id', this.fileId);
                }
            },
            
            HandleResponse(response){
                if(response.xhr.status != 200){
                    toastr.error(JSON.parse(response.xhr.response).message);
                } else {
                    toastr.success(JSON.parse(response.xhr.response).message);
                }

                this.$store.commit('appendFolders', JSON.parse(response.xhr.response));
                this.$parent.closeModal();
            }
        }
	}
</script>
